export function ProcessDoneIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.125 5.25H9.4508C11.7362 5.25 12.8789 5.25 13.3127 5.66047C13.6877 6.01528 13.8539 6.53796 13.7526 7.04416C13.6355 7.62976 12.7026 8.28964 10.8367 9.6094L7.78829 11.7656C5.92243 13.0854 4.98949 13.7452 4.87238 14.3308C4.77114 14.837 4.93731 15.3597 5.31227 15.7145C5.74605 16.125 6.88877 16.125 9.1742 16.125H9.875M6.5 5.25C6.5 6.49264 5.49264 7.5 4.25 7.5C3.00736 7.5 2 6.49264 2 5.25C2 4.00736 3.00736 3 4.25 3C5.49264 3 6.5 4.00736 6.5 5.25Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.8891 11.1992L15.2727 16.1992L13 13.9265"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
